import { useContext, useMemo } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

/**
 * Whether the student-identifier login UI (Student Number / Registration Number
 * radio + locked username input) is enabled for this tenant. Driven by the
 * `studentIdentifierLogin` branding flag so only the student instance opts in.
 */
export const useStudentLogin = () => {
  const { experienceSettings } = useContext(PageContext);

  const isStudentLoginEnabled = useMemo(
    () => experienceSettings?.branding.studentIdentifierLogin === true,
    [experienceSettings]
  );

  return { isStudentLoginEnabled };
};
